import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDevices$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDevices extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'aa869d51ff4178944bacde5a20f12b86d4314fa1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6c854689270ee6e5dd4fd25c65a9fdeeac92d98c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c7bb413872ed54c75e239a680ab84ec6b497cf56', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.5 13.5h-5v-8h14A.5.5 0 0 0 19 5v-.5a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V14a.5.5 0 0 0-.5-.5m3-5.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5zM16 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2m2.5-3h-5V9.5h5zm-12 2.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-devices", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-devices"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-devices":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDevices$1);
            }
            break;
    } });
}

const CosmosIconDevices = CosmosIconDevices$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDevices, defineCustomElement };
